import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {Select} from 'antd'
import {stockFilterTags} from 'Components/Screener/stockFilterTags.js'

@observer
class Tag extends Component {
  handleChange = (value) => {
    this.props.condition.change('tag', value)
  }
  getOptions = () => {
    return stockFilterTags.map(obj => {
      const value = obj.tag
      const name = obj.name || obj.tag
      return(
        <Select.Option key={value} value={value}>{name}</Select.Option>
      )
    })
  }
  render() {
    const tag = this.props.condition.tag
    return(
      <div>
        <label>Tag:</label>
        <Select
          showSearch
          optionFilterProp='children'
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          value={tag}
          onChange={this.handleChange}
          size='large'
        >
          {this.getOptions().map(option => option)}
        </Select>
      </div>
    )
  }
}

export default Tag
